import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastController, LoadingController, ModalController } from '@ionic/angular';
// import { LogInOTPVerificationDialog } from 'src/app/modules/login/login-otp/login-otp.component';
import { LoginService } from 'src/app/services/login.service';
import { Location } from "@angular/common";

@Component({
  selector: 'app-user-login-dialog',
  templateUrl: './user-login-dialog.component.html',
  styleUrls: ['./user-login-dialog.component.scss'],
  standalone: false
})
export class UserLoginDialogComponent {

  isEmailOTPSent: boolean = false;

  // config = {
  //   allowNumbersOnly: false,
  //   length: 4,
  //   isPasswordInput: false,
  //   disableAutoFocus: false,
  //   placeholder: "",
  //   inputStyles: {
  //     width: "40px",
  //     height: "40px",
  //   },
  // };

  // @ViewChild('countdown') counter: CountdownComponent;
  isEmailOTPSend: boolean = false;
  // configTimer = {
  //   leftTime: 30,
  // };
  isOption = "";
  emailValue: any = "";
  emailForm: UntypedFormGroup;
  emailform = {
    Email: "",
  };
  mobileForm: UntypedFormGroup;
  mobileform = {
    code: "+91",
    mobile: "",
  };
  constructor(
    private _formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private location: Location,
    private loginService: LoginService,
    public toastController: ToastController,
    public loadingController: LoadingController, private modalCtrl: ModalController
  ) {
    this.emailForm = this._formBuilder.group({
      Email: ["", [Validators.required, Validators.email]],
    });
    this.mobileForm = this._formBuilder.group({
      code: [""],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
    });
  }
  changeOption(event) {
    this.isOption = event.detail.value;
    // this.mobileForm.reset();
    this.mobileForm.controls.mobile.reset();
    this.emailForm.reset();

  }


  myBackButton() {
    this.location.back();
  }

  closeUserLoginModal() {
    this.modalCtrl.dismiss()
  }
}